import { Box, Button } from '@mui/material'
import React, { createRef, useState } from 'react'
import { IState } from '../../../../redux/reducers/rootReducers';
import { connect } from 'react-redux';
import CustomSelect from '../../../common/customSelect/CustomSelect';
import CustomFormLabel from '../../../common/form-label/CustomFormLabel ';
import { bulkUpdateNewTickets, getBulkNewTicket } from '../../../../redux/actions/TicketsManagement/TicketsManagement';
import { triggerAppAlert } from '../../../../redux/actions/SelfServicePortal/ContactAid/ContactAid';
import { debounce } from 'lodash';
import { useNavigate } from 'react-router-dom';
import TicketTypeDropdown from './TicketTypeDropdown';
import { TextBoxLatest } from '../../../common/TextBoxLatest/TextBoxLatest';
import { returnFormValues } from '../../../helpers/helperFunctions';



interface IAgentGroupOptionProps{
    groups : any[];
    dispatch:any;
    ticketStatus : any [];
    selectedTicketIds:any;
    handleClose:any;
    statusToUpdate?:string;
}
function AgentGroupOption(props:IAgentGroupOptionProps) {
    const noteRef: any = createRef();
    const [fieldsNeedNote] = useState<string[]>(['Closed','Resolved',"OnHold",'Pending']);
    const [fieldsNeedOutcomes] = useState<string[]>(['Closed','Resolved']);
    const {groups=[], ticketStatus=[],dispatch,selectedTicketIds,handleClose,statusToUpdate=""} = props;
    const [agentOptions,setAgentOptions] = useState<any>([])
    const navigate = useNavigate();
    const [values,setValues] = useState<any>({
        fieldVal:  {
            groupId : null,
            agentId : null,
        },
        errors:{
            groupId : null,
            agentId : null,
        }
    })
    const loadTickets = debounce((statusIds:number[]=[],groupIds:number[]=[]) =>{
        dispatch(getBulkNewTicket("",statusIds,groupIds,10000,handleClose))
    },150);
    const getAllTicket = () =>{
        console.log("AllNewTickets", groups,ticketStatus);
        const statusIds:number[] = [];
        const groupIds:number[] = [];
        ticketStatus.map((i:any)=>{if(i.name === "New"){statusIds.push(i.id);}})
        groups.map((i:any)=>{groupIds.push(i.id);})
        loadTickets(statusIds,groupIds);
    }
    
    const validateForm = (formVals: any) =>{
         if(!values?.fieldVal?.ticketType?.id && !values?.fieldVal?.groupId?.id && !values?.fieldVal?.status?.id && noteRef?.current?.value.trim() === ""){
            dispatch(triggerAppAlert(`Please fill the fields to be updated`, 'warning'));
            return false;
        }

        let valid = true;
        let tempObj:any = {};
        // if(!values?.fieldVal?.groupId?.id){
        //     valid =  false;
        //     tempObj.groupId = "Group is required";
        // }
        if(values?.fieldVal?.groupId?.id && !values?.fieldVal?.agentId?.id){
            valid =  false;
            tempObj.agentId = "Owner is required";
        }

        if(values?.fieldVal?.ticketType?.id && !values?.fieldVal?.priority?.id){
            valid =  false;
            tempObj.priority = "Priority is required";
        }

        if(values?.fieldVal?.ticketType?.id && !values?.fieldVal?.category?.id){
            valid =  false;
            tempObj.category = "Category is required";
        }

        if(values?.fieldVal?.ticketType?.id && !values?.fieldVal?.category?.id){
            valid =  false;
            tempObj.category = "Category is required";
        }

        if(fieldsNeedNote.includes(values?.fieldVal?.status?.name || "") && noteRef?.current?.value.trim() === ""){
            valid =  false;
            tempObj.category = "Note is required";
        }
       
        if(fieldsNeedOutcomes.includes(values?.fieldVal?.status?.name || "") && (formVals.hasOwnProperty("closeCategoryID") && !formVals.closeCategoryID)){
            valid =  false;
        }

        if(!valid){
            dispatch(triggerAppAlert(`Please fill all the required fields`, 'warning'));
            setValues({
                ...values,
                errors:{
                    ...values.errors,
                    ...tempObj
                }
            })
        }
        return valid
    }
    const onSubmit = (e: any) =>{
       e.preventDefault();
        const formVals = returnFormValues(e.currentTarget);
        // console.log("formVals", formVals);
        const isValid = validateForm(formVals);

        if(!isValid) return;
        
        const addFields = Object.keys(formVals).reduce((acc, key) => {
            if (key.includes("bulk_update")) {
                let newKey = key.replace("bulk_update_", "");
                acc[newKey] = formVals[key];
            }
            return acc;
        }, {} as any);
        
        
        const {groupId, agentId, status, ticketType, priority, category} = values.fieldVal;
        const payload = {
            "sourceCode": "System",
            "actionType": "BulkUpdate",
            "ticketLogs": {
                "sourceCode": "System",
                "groupId": groupId?.id || 0,
                "agentId": agentId?.id || 0,
                "statusId": status?.id || 0,
                "ticketTypeId": ticketType?.id || 0,
                "priorityId": priority?.id || 0,
                "categoryId": category?.id || 0,
                "note": noteRef?.current?.value || "",
                "ticketAdditionalField" : Object.keys(addFields).length ? addFields : null,
                "outComeCategoryId": Number(formVals?.closeCategoryID) || null
            }
        }
        // return;
        dispatch(bulkUpdateNewTickets(selectedTicketIds,payload,bulkUpdateNewTicketsCB))
    }
    const bulkUpdateNewTicketsCB = () =>{
        getAllTicket();
        handleClose();
        navigate('/TicketManagementSys');
    }
    const tickTypeHandler = (data:any) =>{
        console.log("tickTypeHandler data", data);
        setValues((old:any)=> ({
            ...old,
            fieldVal:  {
                ...old.fieldVal, 
                ...data
            },
            errors:{
                ...values.errors,
                priority: values.errors.priority ? data.priority ? values.errors.priority :  null : null,
                category: values.errors.category ? data.category ? values.errors.category :  null : null,
            }
        }))
    }
    return (
        <Box component={"form"} onSubmit={onSubmit}>
            <Box className="bulk-update-form row m-0">
            <Box className="bulk-update-field col-4">
            <CustomFormLabel
                labelName={"Select Status"}
                isMandotary={false}
                classNames='sml-txt'
            />
            <CustomSelect
                isOpen={false}
                placeholder="Select Status"
                width={"100%"}
                name="statusId"
                isColor={false}
                isDisabled={false}
                isError={values?.errors?.status ? true : false}
                helperText={values?.errors?.status || ""}
                defaultValue={values?.fieldVal?.status || null}
                options={ticketStatus || []}
                handleChange={(e: any) => {
                    setValues({
                        fieldVal:  {
                            ...values.fieldVal,
                            status : e
                        },
                        errors:{
                            ...values.errors,
                            status : null,
                        }
                    })
                }}
                isMulti={false}
                customClassNames="sml-txt-dropdown new-service"
            />
            </Box>
            <Box className="bulk-update-field col-4">

            <CustomFormLabel
                labelName={"Select Group"}
                isMandotary={false}
                classNames='sml-txt'
            />
            <CustomSelect
                isOpen={false}
                placeholder="Select Group"
                width={"100%"}
                name="groupId"
                isColor={false}
                isDisabled={false}
                isError={values?.errors?.groupId ? true : false}
                helperText={values?.errors?.groupId || ""}
                defaultValue={values?.fieldVal?.groupId || null}
                options={groups || []}
                handleChange={(e: any) => {
                    setAgentOptions(e?.agentsList || [])
                    setValues({
                        fieldVal:  {
                            ...values.fieldVal,
                            groupId : e,
                            agentId : null,
                        },
                        errors:{
                            ...values.errors,
                            groupId : null,
                            agentId : null
                        }
                    })
                }}
                isMulti={false}
                customClassNames="sml-txt-dropdown new-service"
            />
            </Box>
            {values?.fieldVal?.groupId &&
                <Box className="bulk-update-field col-4">
                    <CustomFormLabel
                        labelName={"Select Owner"}
                        isMandotary={true}
                        classNames='sml-txt'
                    />
                    <CustomSelect
                        isOpen={false}
                        placeholder="Select Owner"
                        width={"100%"}
                        name="agentId"
                        isColor={false}
                        isDisabled={false}
                        isError={values?.errors?.agentId ? true : false}
                        helperText={values?.errors?.agentId || ""}
                        defaultValue={values?.fieldVal?.agentId || null}
                        options={agentOptions || []}
                        handleChange={(e: any) => {
                            setValues({
                                fieldVal:  {
                                    ...values.fieldVal,
                                    agentId : e,
                                },
                                errors:{
                                    ...values.errors,
                                    agentId : null,
                                }
                            })
                        }}
                        isMulti={false}
                        customClassNames="sml-txt-dropdown new-service"
                    />
                </Box>
            }


            <TicketTypeDropdown showAdditionalFields={["Resolved", "Closed"].includes(values?.fieldVal?.status?.name || "")}  errors={values?.errors} callback={tickTypeHandler} />

            <Box className="bulk-update-field col-12">
                <TextBoxLatest
                    title="Note"
                    isMandotary={fieldsNeedNote.includes(values?.fieldVal?.status?.name || "")}
                    placeholder="Enter the Note"
                    ref={noteRef}
                    // errorMsg={generateErrorList(error.isValid, error.errors, "note")}
                    // isError={generateErrorList(error.isValid, error.errors, "note") ? true : false}
                    // onchangeHandler={unsetNoteFieldErrorMsg}
                    name="note"
                    multiline={true}
                />
            </Box>
            </Box>

            <Box className="pt-1 text-center">
                <Button onClick={handleClose}  variant="outlined" size="small">Cancel</Button> &nbsp;
                <Button variant="contained" type='submit' size="small">Submit</Button>
            </Box>
        </Box>
    )
}


const mapStateToProps = (state:IState) => {
    return ({
        groups : state?.TicketsReducer?.allResponses?.groups,
        ticketStatus : state?.TicketsReducer?.allResponses?.ticketStatus,
    })
  };
  
export default connect(mapStateToProps)(AgentGroupOption);